<div class="stick-top">
  <mat-toolbar>
    <mat-icon>verified_user</mat-icon> Credentials
  </mat-toolbar>
  <div class="hbox lightly-padded button-bar">
    <button mat-raised-button class="primary" routerLink="/credentials/0">
        <mat-icon>add</mat-icon>
        Create a new Credential
      </button>
  </div>
</div>

<div class="padded">
  <table class="basicTable">
    <thead>
      <tr>
        <th>
          <div class="vbox">
            Name
            <input [(ngModel)]="filter.name">
          </div>
        </th>
        <th>
          <div class="vbox">
            Description
            <input [(ngModel)]="filter.description">
          </div>
        </th>
        <th>
          <div class="vbox">
            Type
            <micro-credentialAuthType-select [(credentialAuthType)]="filter.credentialAuthType"></micro-credentialAuthType-select>
          </div>
        </th>
        <th>
          <div class="vbox">
            Company
            <micro-company-select [(companyId)]="filter.companyId"></micro-company-select>
          </div>
        </th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let element of dataSource.data">
        <td [matTooltip]="'Open ' + element.name + ' credentials'"><a routerLink="/credentials/{{element.id}}">{{element.name}}</a></td>
        <td>{{element.description}}</td>
        <td>{{element.credentialAuthType}}</td>
        <td><micro-company-lookup [companyId]="element.companyId" [link]="true"></micro-company-lookup></td>
      </tr>
      <tr *ngIf="dataSource.data?.length === 0">
        <td colspan="100"><em>No results found</em></td>
      </tr>
    </tbody>
    <tfoot>
    <tr>
      <td colspan="100">
        <mat-paginator #paginator
                       (page)="reload()"
                       [pageSize]="10"
                       [pageSizeOptions]="[5, 10, 20]">
        </mat-paginator>
      </td>
    </tr>
    </tfoot>
  </table>
</div>
